import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import classNames from 'classnames';
import { useRecoilState, useRecoilValue, infoModalDataState, translationDataState, tourConfigsState } from '../../../store';

import TourLanguageSelect from '@/components/ticketingNew/components/TourLanguageSelect';

const BaseLayoutStyled = styled.div<{ transparentBg: boolean; rtl?: boolean }>`
  min-height: 100vh;
  margin: auto;
  background-color: ${(p) => (p.transparentBg ? '#E5E5E528' : '#e5e5e5')};
  //background: conic-gradient(from 193.61deg at 46.18% 51.15%, #000000 -139.17deg, #eeeeee 10.44deg, #ffffff 157.82deg, #000000 220.83deg, #eeeeee 370.44deg);
  ${({ rtl }) => `${rtl ? 'direction: rtl; text-align: right;' : ''}`};

  header {
    height: 58px;
    width: 100%;
    background-color: #282828;
    color: white;
    display: flex;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    z-index: 1;

    .bl-header-clientPic {
      //left: 15px;
      //position: absolute;
      //background: #ccadad;
      width: 100px;
      height: 100%;
      margin-right: 15px;

      &.forMobile {
        display: none;
      }
      object-fit: contain;

      @media screen and (max-width: 760px) {
        display: none;
        &.forMobile {
          display: block;
          order: 2;
          width: 33.33%;
          margin: 0;
        }
      }
    }

    .bl-header-block {
      font-size: 16px;
      position: absolute;
      display: flex;
      align-items: center;
      margin: auto;
      justify-content: center;
      height: 100%;
      width: auto;
      left: ${({ rtl }) => `${rtl ? '50px' : 'initial'}`};
      right: ${({ rtl }) => `${rtl ? 'initial' : '50px'}`};

      @media screen and (max-width: 760px) {
        width: 100%;
        right: 0;
        //right: auto;
        span {
          display: none;
        }
      }

      & > * {
        line-height: 1;
      }

      .bl-header-lang {
        display: flex;
        align-items: center;

        i {
          font-size: 16px;
        }

        select {
          line-height: 1;
          background: transparent;
          color: white;
          font-size: 16px;
          padding: 0;
          min-width: 43px;
        }

        @media screen and (max-width: 760px) {
          order: 1;
          width: 33.33%;
          padding-left: 15px;
        }
      }

      .loginButton-wrap {
        .signButton {
          border: 1.5px solid #ffffff;
          box-sizing: border-box;
          filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
          border-radius: 6px;
          width: 83px;
          height: 31px;
          background: transparent;
          color: white;
          margin: 0 15px;
        }

        @media screen and (max-width: 760px) {
          order: 3;
          margin: 0;
          text-align: right;
          width: 33.33%;
          padding-right: 15px;
          button {
            margin: 0 !important;
          }
        }
      }

      .buyNowLink {
        margin: 0 15px;
        text-decoration: underline;

        &:hover,
        &:active {
          color: white;
        }

        @media screen and (max-width: 760px) {
          order: 3;
          width: 33.33%;
          text-align: right;
          margin: 0;
          padding-right: 15px;
        }
      }
    }
  }

  .bl-inner-content {
    min-height: calc(100vh - 155px);
    overflow: hidden;
  }

  footer {
    height: 97px;
    width: 100%;
    background-color: #282828;
    color: white;
    margin-top: 35px;

    .bl-footer-copyright {
      height: 45px;
      margin: 30px;
      position: absolute;
      display: flex;
      align-items: center;
      font-size: 22px;

      span {
        margin: 0 15px 0 5px;
      }

      img {
        margin-top: 3px;
        margin-left: 5px;
        width: 101px;
        object-fit: contain;
        height: 46px;

        &[alt='treedis'] {
          filter: brightness(0) saturate(100%) invert(45%) sepia(15%) saturate(3730%) hue-rotate(311deg) brightness(90%) contrast(105%);
        }
      }
    }
  }
`;

const ClientPic = ({ forMobile = false, src = '' }) =>
  src ? (
    <img src={src} alt="client_logo" className={classNames('bl-header-clientPic', forMobile && 'forMobile')} />
  ) : (
    <div className={classNames('bl-header-clientPic', forMobile && 'forMobile')} />
  );

const BaseLayout = (props: any) => {
  const { location, children, tourId = 0, whiteLabelData = {}, transparentBg = false } = props;
  const { rtl } = useRecoilValue(tourConfigsState);

  const {
    log_in = 'log in',
    buy_now = 'Buy now',
    powered_by = 'Powered by',
    already_have_a_ticket = 'Already have a ticket?',
    dont_have_a_tour_ticket = "Don't have a tour ticket?",
  } = useRecoilValue(translationDataState);

  const isLoginPage = location.pathname.includes('login');
  const pathnames = location.pathname.split('/');
  pathnames.shift();
  const homeLink = `/${pathnames[0]}/${pathnames[1]}${pathnames[0] === 'experience' ? `/${pathnames[2]}` : ''}/book`;
  const loginLink = `/${pathnames[0]}/${pathnames[1]}${pathnames[0] === 'experience' ? `/${pathnames[2]}` : ''}/login`;
  const clietnLogoSrc = whiteLabelData.logo && whiteLabelData?.logo?.includes('clients') ? whiteLabelData.logo : '';

  const [infoModalData, setInfoModalData] = useRecoilState(infoModalDataState);
  const closeInfoModal = () => setInfoModalData({ ...infoModalData, isOpen: false });

  return (
    <BaseLayoutStyled transparentBg={transparentBg} rtl={rtl}>
      <header>
        <ClientPic src={clietnLogoSrc} />
        <div className="bl-header-block">
          <ClientPic forMobile={true} src={clietnLogoSrc} />
          <span>{!isLoginPage ? already_have_a_ticket : dont_have_a_tour_ticket}</span>
          {isLoginPage && (
            <Link to={homeLink} className="buyNowLink" onClick={closeInfoModal}>
              {buy_now}
            </Link>
          )}
          {!isLoginPage && (
            <Link to={loginLink} className="loginButton-wrap" onClick={closeInfoModal}>
              <button className="signButton">{log_in}</button>
            </Link>
          )}
          <TourLanguageSelect tourId={tourId} />
        </div>
      </header>

      <div className="bl-inner-content">{children}</div>
      <footer>
        <div className="bl-footer-copyright">
          <i className="far fa-copyright" />
          <span>{powered_by}</span>
          {whiteLabelData ? (
            <a href={whiteLabelData?.domainUrl?.includes('http') ? whiteLabelData.domainUrl : 'http://' + whiteLabelData.domainUrl} rel="noreferrer" target="_blank">
              <img src={whiteLabelData.logo} alt="whitelabel logo" />
            </a>
          ) : (
            <a href="https://treedis.com/" rel="noreferrer" target="_blank">
              <img className="treedis" src="/logo.png" alt="treedis logo" />
            </a>
          )}
        </div>
      </footer>
    </BaseLayoutStyled>
  );
};

export default withRouter(BaseLayout);
